import { useTelegram } from '@st/telegram/composables/useTelegram'
import { useSettingsStore } from '@st/core/stores/useSettingsStore'

export default defineNuxtPlugin({
  order: 7,
  name: 'telegramInWebWatcher',
  setup() {
    const router = useRouter()
    const { isTgMiniAppInSafari } = useTelegram()
    const { settings } = storeToRefs(useSettingsStore())
    const telegramAppUrl = computed(
      () => settings.value?.frontTelegramMiniAppUrl ?? '',
    )

    if (isTgMiniAppInSafari.value) {
      router.replace({
        query: {
          modal: 'webTelegramForbidden',
          telegramAppUrl: telegramAppUrl.value,
        },
      })
    }
  },
})
